import { Slot, SlotAction, SLOT } from "./types";

export const addSlotData = (slot: Slot): SlotAction => {
    return {
        type: SLOT.ADD_SLOT_DATA,
        payload: slot
    };
}